import {MenuItem, Select} from "@mui/material";
import type {TabRoute} from "./PageShell";

interface Props {
    tabs: TabRoute[];
    value: string;
    onSelect: (path: string) => void;
    compact: boolean;
}

export function PageShellMobileTabSelect({tabs, value, onSelect, compact}: Props) {
    return (
        <Select<string>
            size="small"
            value={value}
            onChange={event => onSelect(event.target.value)}
            inputProps={{"aria-label": "Page section"}}
            className="hide-on-print"
            sx={{
                display: compact ? "inline-flex" : "none",
                justifySelf: "end",
                minWidth: 0,
                maxWidth: {xs: "34vw", sm: "40vw"},
                height: 40,
                bgcolor: "#fff",
                fontWeight: 600,
            }}
        >
            {tabs.map(tab => (
                <MenuItem key={tab.path} value={tab.path}>
                    {tab.label}
                </MenuItem>
            ))}
        </Select>
    );
}
